// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__E6IWo","list":"BalanceDue_list__1QadH","listRow":"BalanceDue_listRow__2_87K","total":"BalanceDue_total__3WYEX"};